import { createFileRoute } from '@tanstack/react-router';

import { MarketingFeaturesV2 } from '../features/marketing/marketing-features-v2';
import '../styles/marketing-features-v2.css';

export const Route = createFileRoute('/features')({ component: MarketingFeaturesV2 });
